module.exports = __webpack_public_path__ + "img/cg.8373836c.svg";